import { render, staticRenderFns } from "./TableShops.vue?vue&type=template&id=012be592"
import script from "./TableShops.vue?vue&type=script&lang=js"
export * from "./TableShops.vue?vue&type=script&lang=js"
import style0 from "./TableShops.vue?vue&type=style&index=0&id=012be592&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports